import { a as i, e as n } from "./useActions-Cd7V2qfb.js";
import { u as r } from "./eventBusSubscribe-Cxw0xUAm.js";
import { s as c } from "./index.es-XNBESE3P.js";
import { l as u } from "./logger-_fg_Za9y.js";
import { useEffect as l } from "preact/hooks";
function S() {
  const { pageType: t } = i(), o = n();
  return r({
    event: "actions/newSearch",
    callback: (e) => {
      t === e.targetStore && o.newSearch(e.query, e.options);
    }
  }), r({
    event: "actions/updateSearch",
    callback: (e) => {
      t === e.targetStore && o.updateSearch(e.query, e.options);
    }
  }), r({
    event: "actions/replaceFilter",
    callback: (e) => {
      t === e.targetStore && o.replaceFilter(e.field, e.value);
    }
  }), r({
    event: "actions/toggleProductFilter",
    callback: (e) => {
      t === e.targetStore && o.toggleProductFilter(e.field, e.value, e.active);
    }
  }), null;
}
function v() {
  l(() => {
    const t = window.setTimeout(() => {
      u.error("Nosto client script has not loaded after 3 seconds.");
    }, 3e3);
    c(() => {
      window.clearTimeout(t);
    });
  }, []);
}
const p = {
  defaultCurrency: "EUR",
  queryModifications: (t) => t
};
export {
  S,
  p as d,
  v as u
};
